import { Search } from "../../../search/Search.js";
import { SearchRequest } from "../../../search/SearchRequest.js";


function resolveUri_(uri) {
    if (!uri) return "";
    let url = uri;

    if (uri.startsWith('doi:')) {
        url = 'https://doi.org/' + uri;
    } else if (uri.startsWith('hdl:')) {
        url = 'https://hdl.handle.net/' + uri;
    }

    return url;
}


function findLink_(result) {
    let link = "";

    // prepare doi or hdl
    if (result.identifiers) {
        for (let i in result.identifiers) {
            if (['doi', 'hdl'].includes(result.identifiers[i].type)) {
                link = resolveUri_(result.identifiers[i].id);
            }
        }
        if (link.length) return link;
    }

    if (result.resources) {
        const resources = result.resources;
        for (let i = 0; i < resources.length; ++i) {
            if (resource.type == 'link') {
                return resource.url;
            }
        }

    }

    return "";
}


/**
 * A function for doing a search request in the elasticsearch index
 * 
 * @param {string[]} args indices seperated by comma, query, geometry
 * @returns {string} container for search results
 * 
 * @memberof vef.map.popup.templateFunctions
 */
export function search(args, data, postProcessingQueue) {
    const indices = (args.length >= 1) ? args[0].split(",") : ["harvest", "harvest-extern"];
    const query = (args.length >= 2) ? args[1] : "";
    const geometry = (args.length >= 3) ? args[2] : null;

    const id = `search_${postProcessingQueue.length}`;

    postProcessingQueue.push(container => {
        const target = container.querySelector("#" + id);

        const searchInstance = new Search("https://marine-data.de/rest/search/");
        searchInstance.on("process", e => {
            // get link
            const link = findLink_(e);
            let authors = [];

            // prepare authors
            if (e.persons && e.persons.author) {
                for (let p in e.persons.author) {
                    let person = e.persons.author[p];
                    authors.push(person.fullname);
                }
            }

            target.innerHTML += `
                <div style="margin:0 0 10px 0; padding:10px; background-color:#FFFFFF;">
                    <b style="margin-bottom:7px; display:block;"><a target="_blank" href="${link}">${e.title}</a></b>
                    <span style="margin-bottom:7px; display:block;">${authors.join('; ')}</span>
                    <a style="margin-bottom:7px; display:block;" target="_blank" href="${link}">${link}</a>
                </div>
            `;
        });
        searchInstance.on("finished", e => {
            target.innerHTML += "<div>Total Hits: <b>" + e.totalHits + "</b></div>"
        });

        const request = new SearchRequest(...indices);
        request.excludes = ['metadata', 'keywords.region*', 'keywords.vmap*'];
        request.hits = 5;
        request.query = query;
        request.sorts = ["date:desc"];

        if (geometry) request.queryGeometries.geometry = [geometry];

        searchInstance.request(request);
    });

    return `<div id="${id}"></div>`;
}